import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchItem, updateItem } from "../api";
import { TextField, Button, MenuItem, Container, Paper, Typography } from "@mui/material";

const EditItem = () => {
    const { eventId, itemId } = useParams();
    const navigate = useNavigate();

    const [itemName, setItemName] = useState("");
    const [category1, setCategory1] = useState("");
    const [category2, setCategory2] = useState("");
    const [category3, setCategory3] = useState("");
    const [quantity, setQuantity] = useState(1);
    const [purchaseUrl, setPurchaseUrl] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [imageFile, setImageFile] = useState(null);

    useEffect(() => {
        fetchItem(eventId, itemId).then(item => {
            setItemName(item.itemName);
            setCategory1(item.category1);
            setCategory2(item.category2);
            setCategory3(item.category3);
            setQuantity(item.quantity);
            setPurchaseUrl(item.purchaseUrl || "");
            setImageUrl(item.imageUrl || "");
        });
    }, [eventId, itemId]);

    const uploadImageToS3 = async (file) => {
        console.log("🟡 アップロード処理開始");
        const res1 = await fetch("https://qt3zit1045.execute-api.ap-northeast-1.amazonaws.com/dev/getUploadUrl", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                eventId,
                itemId,
                fileType: file.type
            })
        });

        // const { uploadUrl, imageUrl } = await res1.json();
        
        const result = await res1.json();
        console.log("🟢 getUploadUrl 成功:", result);
        const uploadUrl = result.uploadURL; // ← フロント側で正しいキー名に合わせる
        const imageUrl = result.imageUrl;   


        const res2 = await fetch(uploadUrl, {
            method: "PUT",
            headers: { "Content-Type": file.type },
            body: file
        });

        console.log("🟢 PUTステータスコード:", res2.status);
        if (!res2.ok) {
          throw new Error("画像のアップロードに失敗しました");
        }

        return imageUrl;
    };

    const deleteImage = async () => {
        if (!window.confirm("画像を削除してもよいですか？")) return;
      
        try {
          const res = await fetch("https://qt3zit1045.execute-api.ap-northeast-1.amazonaws.com/dev/deleteImage", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ eventId, itemId })
          });
      
          if (!res.ok) throw new Error("S3削除に失敗しました");
      
          console.log("🗑️ S3画像削除成功");
      
          // DynamoDB上のimageUrlを空に更新
          await updateItem(eventId, itemId, {
            itemName,
            category1,
            category2,
            category3,
            quantity,
            imageUrl: "",
            purchaseUrl
          });
      
          setImageUrl("");
          alert("画像を削除しました");
        } catch (error) {
          console.error("❌ 削除失敗:", error);
          alert("画像削除に失敗しました");
        }
      };

    const handleSubmit = async (event) => {
        event.preventDefault();

        console.log("📸 編集：画像ファイルが選択されているか？", imageFile);

        try {
            let finalImageUrl = imageUrl;

            if (imageFile) {
                finalImageUrl = await uploadImageToS3(imageFile);
                console.log("✅ アップロード成功後の imageUrl:", finalImageUrl);
                setImageUrl(finalImageUrl);
            }

            await updateItem(eventId, itemId, {
                itemName,
                category1,
                category2,
                category3,
                quantity,
                imageUrl: finalImageUrl,
                purchaseUrl
            });

            alert("品物を更新しました！");
            navigate(`/events/${eventId}`);
        } catch (error) {
            console.error("❌ エラー:", error);
            alert("エラーが発生しました。");
        }
    };

    return (
        <Container maxWidth="sm">
            <Paper elevation={3} style={{ padding: "20px", marginTop: "20px" }}>
                <Typography variant="h4" gutterBottom>品物を編集</Typography>
                <form onSubmit={handleSubmit}>
                    <TextField label="品物名" fullWidth value={itemName} onChange={(e) => setItemName(e.target.value)} required margin="normal" />
                    <TextField select label="カテゴリ1" fullWidth value={category1} onChange={(e) => setCategory1(e.target.value)} required margin="normal">
                        <MenuItem value="食べ物">食べ物</MenuItem>
                        <MenuItem value="飲み物">飲み物</MenuItem>
                    </TextField>
                    <TextField label="カテゴリ2" fullWidth value={category2} onChange={(e) => setCategory2(e.target.value)} margin="normal" />
                    <TextField label="カテゴリ3" fullWidth value={category3} onChange={(e) => setCategory3(e.target.value)} margin="normal" />
                    <TextField label="数量" type="number" fullWidth value={quantity} onChange={(e) => setQuantity(e.target.value)} required margin="normal" />
                    <TextField label="参考URL" fullWidth value={purchaseUrl} onChange={(e) => setPurchaseUrl(e.target.value)} margin="normal" />

                    {imageUrl && (
                        <div style={{ marginTop: "16px", textAlign: "center" }}>
                            <img
                                src={`${imageUrl}?t=${Date.now()}`} // キャッシュ対策
                                alt="現在の画像"
                                style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
                            />

                        <Button
                        variant="outlined"
                        color="error"
                        style={{ marginTop: "8px" }}
                        onClick={deleteImage}
                        >
                        画像を削除
                        </Button>
                        </div>
                    )}

                    <Button variant="outlined" component="label" style={{ marginTop: "16px" }}>
                        画像を変更
                        <input type="file" hidden accept="image/*" onChange={(e) => setImageFile(e.target.files[0])} />
                    </Button>

                    <Button type="submit" variant="contained" color="primary" fullWidth style={{ marginTop: "20px" }}>
                        更新
                    </Button>
                    <Button variant="outlined" color="secondary" fullWidth style={{ marginTop: "10px" }} onClick={() => navigate(`/events/${eventId}`)}>
                        戻る
                    </Button>
                </form>
            </Paper>
        </Container>
    );
};

export default EditItem;
